import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==============================================================================
// 1. LIGHT GROUPINGS (Strictly organized to prevent impossible builds)
// ==============================================================================
export const LIGHT_GROUPS = {
    // --- RIGHT HAND GROUPS ---
    GLOCK_RH: ["pl350", "tlr1_hl", "tlr2", "tlr7_a_x", "tlr7_hlx", "wild1", "wild2", "x300u_a", "x400", "xc2", "xvl2"],
    SHADOW_SYS_RH: ["tlr1_hl", "tlr7_a_x", "tlr7_hlx", "x300u_a"],
    CORE_3_RH: ["tlr1_hl", "tlr7_a_x", "x300u_a"], // Staccato, Walther, FN 509
    P320_STD_RH: ["tlr1_hl", "tlr7_a_x", "wild1", "wild2", "x300u_a", "xc2"],
    P320_X5_RH: ["tlr1_hl", "tlr7_a_x", "wild1", "x300u_a"],
    CZ_P10C_RH: ["inforce_aplc_glock", "tlr1_hl", "tlr7_a_x", "wild1", "x300u_a"],
    CZ_P10F_RH: ["tlr1_hl", "tlr7_a_x", "wild1", "x300u_a"],
    CZ_SHADOW2_RH: ["tlr7_a_x", "tlr7_hlx", "x300u_a"],
    MACRO_RH: ["tlr7_a_x", "tlr7_hlx", "tlr7_sub_1913"],

    // --- LEFT HAND GROUPS ---
    GLOCK_LH: ["tlr1_hl", "tlr7_a_x", "tlr7_hlx", "x300u_a", "wild1"],
    CORE_4_LH: ["tlr1_hl", "tlr7_a_x", "tlr7_hlx", "x300u_a"], 
    CORE_3_LH: ["tlr1_hl", "tlr7_a_x", "x300u_a"], 
    FN_509_LH: ["tlr1_hl", "x300u_a"],
    MACRO_LH: ["tlr7_a_x", "tlr7_hlx", "tlr7_sub_1913"], 

    // --- SPECIFICS ---
    TLR7_AND_X300: ["tlr7_a_x", "x300u_a"],
    X300_ONLY: ["x300u_a"],
    TLR7_ONLY: ["tlr7_a_x"],
    SUB_GLOCK: ["tlr7_sub_glock", "xsc"],
    SUB_SIG: ["tlr7_sub_p365"],
    NONE: []
};

// ==============================================================================
// FLAG TEMPLATES 
// ==============================================================================
const ALL_CONFIGS  = { lh_iwb: true, lh_lb_iwb: true, rh_iwb: true, rh_lb_iwb: true, lh_daisho: true, lh_lb_daisho: true, rh_daisho: true, rh_lb_daisho: true };
const IWB_ONLY     = { lh_iwb: true, lh_lb_iwb: false, rh_iwb: true, rh_lb_iwb: false, lh_daisho: false, lh_lb_daisho: false, rh_daisho: false, rh_lb_daisho: false };
const IWB_AND_LB   = { lh_iwb: true, lh_lb_iwb: true, rh_iwb: true, rh_lb_iwb: true, lh_daisho: false, lh_lb_daisho: false, rh_daisho: false, rh_lb_daisho: false };
const DAISHO_NO_LB = { lh_iwb: true, lh_lb_iwb: false, rh_iwb: true, rh_lb_iwb: false, lh_daisho: true, lh_lb_daisho: false, rh_daisho: true, rh_lb_daisho: false };

// Strict Right-Hand Only Flags
const RH_IWB_ONLY       = { lh_iwb: false, lh_lb_iwb: false, rh_iwb: true, rh_lb_iwb: false, lh_daisho: false, lh_lb_daisho: false, rh_daisho: false, rh_lb_daisho: false };
const RH_IWB_AND_DAISHO = { lh_iwb: false, lh_lb_iwb: false, rh_iwb: true, rh_lb_iwb: false, lh_daisho: false, lh_lb_daisho: false, rh_daisho: true, rh_lb_daisho: false };

export const limitedEditionData = {
  // ==============================================================================
  // GUN MODELS
  // ==============================================================================
  guns: [
    // --- GLOCK ---
    { id: "glock_19", name: "GLOCK 19 (FITS: GEN3-6, 19M, 19X, G45, 19 MOS)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.GLOCK_RH, supported_lights_lh: LIGHT_GROUPS.GLOCK_LH },
    { id: "glock_17", name: "GLOCK 17/31 (FITS: GEN3-6, 17M, 17 MOS, G47)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.GLOCK_RH, supported_lights_lh: LIGHT_GROUPS.GLOCK_LH },
    { id: "glock_34", name: "GLOCK 34/35 (FITS: GEN3-6, MOS)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.GLOCK_RH, supported_lights_lh: LIGHT_GROUPS.GLOCK_LH },
    { id: "glock_43x", name: "GLOCK 43/43X (Includes MOS Models)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SUB_GLOCK, supported_lights_lh: LIGHT_GROUPS.SUB_GLOCK },
    { id: "glock_48", name: "GLOCK 48 (Includes MOS Models)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SUB_GLOCK, supported_lights_lh: LIGHT_GROUPS.SUB_GLOCK },
    { id: "glock_26", name: "GLOCK 26/27/33", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "glock_22_gen24", name: "GLOCK 22 (Gen 2-4)", ...IWB_AND_LB, supported_lights: LIGHT_GROUPS.GLOCK_RH, supported_lights_lh: LIGHT_GROUPS.GLOCK_LH },
    { id: "glock_22_gen5", name: "GLOCK 22 (Gen 5)", ...IWB_AND_LB, supported_lights: LIGHT_GROUPS.GLOCK_RH, supported_lights_lh: LIGHT_GROUPS.GLOCK_LH },

    // --- SIG SAUER ---
    { id: "sig_p365_xmacro", name: "SIG P365 X-Macro (Fits Tacops Models)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.MACRO_RH, supported_lights_lh: LIGHT_GROUPS.MACRO_LH },
    { id: "sig_p365_xl", name: "SIG P365XL", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SUB_SIG, supported_lights_lh: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p365_fuse", name: "SIG P365 FUSE", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.MACRO_RH, supported_lights_lh: LIGHT_GROUPS.MACRO_LH },
    { id: "sig_p365_axg_gen1", name: "SIG P365-AXG Legion (GEN 1 ONLY)", ...ALL_CONFIGS, supported_lights: ["tlr7_sub_1913"], supported_lights_lh: ["tlr7_sub_1913"] },
    { id: "sig_p365_axg_gen2", name: "SIG P365-AXG Black/Legion (GEN 2 ONLY)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.MACRO_RH, supported_lights_lh: LIGHT_GROUPS.MACRO_LH },
    { id: "sig_p320_c", name: "SIG P320C (XCARRY, XCOMPACT, M18, TAC OPS)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.P320_STD_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "sig_p320_fs", name: "SIG P320FS (P320 FULL SIZE, M17, XCARRY)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.P320_STD_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "sig_p320_x5", name: "SIG P320 X5/LEGION", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.P320_X5_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "sig_p226", name: "SIG P226 (SAO Legion, P226 SIG Rail)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_AND_X300, supported_lights_lh: LIGHT_GROUPS.TLR7_AND_X300 },
    { id: "sig_p226_mk25", name: "SIG P226 Mk25", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY },
    { id: "sig_p226_xcarry_legion", name: "SIG P226-XCarry Legion (3.8\")", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_p226_x_legion", name: "SIG P226-X Legion (4.4\")", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_p226_xfive_us", name: "SIG P226-XFIVE/LEGION (2022 US VERSION)", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_p229", name: "SIG P229 (9mm Only)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_AND_X300, supported_lights_lh: LIGHT_GROUPS.TLR7_AND_X300 },
    
    // PTEX Models - LH Lightbearing completely disabled
    { id: "sig_p320_ptex_c", name: "SIG P320C PF320PTEX", ...ALL_CONFIGS, lh_daisho: false, lh_lb_iwb: false, lh_lb_daisho: false, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: [] }, 
    { id: "sig_p320_ptex_fs", name: "SIG P320FS PF320PTEX", ...ALL_CONFIGS, lh_daisho: false, lh_lb_iwb: false, lh_lb_daisho: false, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: [] }, 
    
    { id: "sig_p320_xten_comp", name: "SIG P320-XTEN COMP", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_p320_xten", name: "SIG P320-XTEN", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_1911_xfull", name: "SIG 1911 X-FULL 5\"", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_1911_xcarry", name: "SIG 1911 X-CARRY 4.25\"", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sig_p365_base", name: "SIG P365/P365X", ...IWB_AND_LB, supported_lights: LIGHT_GROUPS.SUB_SIG, supported_lights_lh: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p211_gto", name: "SIG P211-GTO", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE }, 

    // --- CZ ---
    { id: "cz_p01", name: "CZ P-01", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: ["tlr7_a_x"] },
    { id: "cz_p07", name: "CZ P-07", ...ALL_CONFIGS, rh_daisho: false, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY }, 
    { id: "cz_p09", name: "CZ P-09", ...ALL_CONFIGS, rh_daisho: false, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY }, 
    { id: "cz_p10c", name: "CZ P-10 C", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CZ_P10C_RH, supported_lights_lh: ["x300u_a", "tlr7_a_x", "inforce_aplc_glock"] },
    { id: "cz_p10f", name: "CZ P-10 F", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CZ_P10F_RH, supported_lights_lh: ["x300u_a", "tlr7_a_x"] },
    { id: "cz_p10m", name: "CZ P-10 M", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "cz_p10s", name: "CZ P-10 S", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY },
    { id: "cz_shadow2", name: "CZ Shadow 2", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CZ_SHADOW2_RH, supported_lights_lh: LIGHT_GROUPS.CZ_SHADOW2_RH },
    { id: "cz_shadow2_carry", name: "CZ Shadow 2 Carry", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CZ_SHADOW2_RH, supported_lights_lh: LIGHT_GROUPS.CZ_SHADOW2_RH },
    { id: "cz_shadow2_compact", name: "CZ Shadow 2 Compact", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CZ_SHADOW2_RH, supported_lights_lh: LIGHT_GROUPS.CZ_SHADOW2_RH },
    { id: "cz_p09c_noc", name: "CZ P-09 C Nocturne", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "cz_p09f_noc", name: "CZ P-09 F Nocturne", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "cz_sp01", name: "CZ SP-01", ...DAISHO_NO_LB, rh_daisho: false, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE }, 

    // --- SHADOW SYSTEMS ---
    { id: "ss_cr920", name: "Shadow Systems CR920", ...ALL_CONFIGS, supported_lights: ["tlr7_sub_glock"], supported_lights_lh: ["tlr7_sub_glock"] },
    { id: "ss_mr920", name: "Shadow Systems MR920", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },
    { id: "ss_mr920l", name: "Shadow Systems MR920L", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },
    { id: "ss_xr920", name: "Shadow Systems XR920", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },
    { id: "ss_dr920", name: "Shadow Systems DR920", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },
    { id: "ss_dr920p", name: "Shadow Systems DR920P", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },
    { id: "ss_dr920l", name: "Shadow Systems DR920L", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.SHADOW_SYS_RH, supported_lights_lh: LIGHT_GROUPS.CORE_4_LH },

    // --- SMITH & WESSON ---
    { id: "sw_mp10_36", name: "S&W M&P 1.0 9/40 3.6\"", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_mp10_4", name: "S&W M&P 1.0 9/40 4.0\"", ...ALL_CONFIGS, lh_daisho: false, rh_daisho: false, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY }, 
    { id: "sw_mp10_425", name: "S&W M&P 1.0 9/40 4.25\"", ...ALL_CONFIGS, lh_daisho: false, rh_daisho: false, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY }, 
    { id: "sw_mp10_5", name: "S&W M&P 1.0 9/40 5.0\"", ...ALL_CONFIGS, lh_daisho: false, rh_daisho: false, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY }, 
    { id: "sw_mp2_10_4", name: "S&W M&P 2.0 10MM 4.0\"", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_mp2_10_46", name: "S&W M&P 2.0 10MM 4.6\"", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_mp20_36", name: "S&W M&P 2.0 9/40 3.6\"", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_mp20_4", name: "S&W M&P 2.0 9/40 4.0\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "sw_mp20_425", name: "S&W M&P 2.0 9/40 4.25\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "sw_mp20_5", name: "S&W M&P 2.0 9/40 5.0\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    // M&P 2.0 METAL / STEEL FRAME - flags mirror the polymer 2.0 entries above
    { id: "sw_mp20_metal_36", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 3.6\"", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_mp20_metal_4", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.0\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "sw_mp20_metal_425", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.25\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "sw_mp20_metal_5", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 5.0\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "sw_shield_x", name: "S&W M&P Shield X", ...ALL_CONFIGS, supported_lights: ["tlr7_sub_1913"], supported_lights_lh: ["tlr7_sub_1913"] },
    { id: "sw_shield_plus_comp", name: "S&W Shield Plus Carry Comp", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_shield_plus", name: "S&W Shield Plus", ...IWB_ONLY, supported_lights: ["tlr7_sub_1913"], supported_lights_lh: ["tlr7_sub_1913"] },
    { id: "sw_shield_940", name: "S&W Shield / 2.0 (9mm Only)", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_shield_ez_380", name: "S&W M&P Shield 380 EZ", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_bodyguard2", name: "S&W M&P Bodyguard 2.0", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sw_csx", name: "S&W CSX", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- STACCATO ---
    { id: "staccato_c2", name: "Staccato C2", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "staccato_p", name: "Staccato P", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "staccato_xc", name: "Staccato XC", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "staccato_xl", name: "Staccato XL", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },

    // --- WALTHER ---
    { id: "walther_pdp_4", name: "Walther PDP Compact/Full Size 4\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "walther_pdp_45", name: "Walther PDP Full Size 4.5\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "walther_pdp_5", name: "Walther PDP Full Size 5\"", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.CORE_3_LH },
    { id: "walther_q4", name: "Walther Q4", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "walther_q5", name: "Walther Q5", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- FN HERSTAL ---
    { id: "fn_309", name: "FN 309", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "fn_509_cc_edge", name: "FN 509 CC EDGE", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.FN_509_LH },
    { id: "fn_509_ls_edge", name: "FN 509 LS EDGE", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.FN_509_LH },
    { id: "fn_509_tac", name: "FN 509/M/TAC", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.FN_509_LH },
    { id: "fn_509c", name: "FN 509C/509C Tactical", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.CORE_3_RH, supported_lights_lh: LIGHT_GROUPS.FN_509_LH },
    { id: "fn_reflex", name: "FN REFLEX/XL MRD", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "fn_510_545", name: "FN 510/545 TACTICAL", ...IWB_AND_LB, supported_lights: ["tlr1_hl", "x300u_a"], supported_lights_lh: ["tlr1_hl"] },
    { id: "fn_57", name: "FN 5.7 Mk3", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "fn_503", name: "FN 503", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "fn_fnx45", name: "FN FNX45/TACTICAL", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "fn_hi_power_2022", name: "FN High Power (2022)", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- AREX ---
    { id: "arex_delta", name: "AREX DELTA (1.0 / 2.0 M & X)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY },
    { id: "arex_delta_l", name: "AREX DELTA L", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.TLR7_ONLY, supported_lights_lh: LIGHT_GROUPS.TLR7_ONLY },
    { id: "arex_alpha", name: "AREX Alpha", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "arex_zero2", name: "AREX Zero 2", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- BERETTA ---
    { id: "beretta_m9", name: "Beretta M9A1/M9A3/M9A4/92G/92X", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "beretta_80x", name: "Beretta 80X Cheetah", ...IWB_AND_LB, supported_lights: ["tlr7_a_x", "tlr7_sub_1913"], supported_lights_lh: ["tlr7_a_x", "tlr7_sub_1913"] },
    { id: "beretta_apx_a1_fs", name: "Beretta APX-A1 Full Size", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "beretta_apx_a1_c", name: "Beretta APX-A1 Compact", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "beretta_px4", name: "Beretta PX4 Storm", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "beretta_px4_c", name: "Beretta PX4 Storm Compact", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- PSA ---
    { id: "psa_57_rock", name: "PSA 5.7 Rock", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "psa_57_rock_c", name: "PSA 5.7 Rock Compact", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "psa_dagger", name: "PSA Dagger Full Size-S", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "psa_dagger_sx", name: "PSA Dagger Full Size-SX", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "psa_micro_dagger", name: "PSA Micro Dagger", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- KAHR ---
    { id: "kahr_cm9", name: "Kahr CM9", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "kahr_cw9", name: "Kahr CW9", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "kahr_ct9", name: "Kahr CT9", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },

    // --- STEYR ---
    { id: "steyr_atd_4", name: "Steyr ATD 4\"", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "steyr_c9", name: "Steyr C9-A2", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "steyr_m9", name: "Steyr M9-A2", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "steyr_l9", name: "Steyr L9-A2", ...RH_IWB_AND_DAISHO, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    
    // --- MISCELLANEOUS / OTHERS ---
    { id: "archon_b", name: "ARCHON Type B", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "archon_b_comp", name: "ARCHON Type B W/ VP Armory Comp", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.X300_ONLY, supported_lights_lh: LIGHT_GROUPS.X300_ONLY },
    { id: "hk_cc9", name: "HK CC9", ...ALL_CONFIGS, supported_lights: ["xsc"], supported_lights_lh: ["xsc"] },
    { id: "icarus_365_xmacro", name: "Icarus 365X/365XL (EVO/XMacro)", ...ALL_CONFIGS, supported_lights: LIGHT_GROUPS.MACRO_RH, supported_lights_lh: LIGHT_GROUPS.MACRO_LH },
    { id: "icarus_365_pmm", name: "Icarus 365XL PMM Comp", ...ALL_CONFIGS, supported_lights: ["tlr7_a_x", "tlr7_hlx", "tlr7_sub_1913"], supported_lights_lh: ["tlr7_a_x", "tlr7_hlx", "tlr7_sub_1913"] },
    { id: "icarus_ace_311", name: "Icarus ACE 365-311", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "icarus_ace_311_fuse", name: "Icarus ACE 365-311 FUSE", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "icarus_air", name: "Icarus AIR (XMacro Length)", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "daniel_h9", name: "Daniel H9", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "iwi_masada", name: "IWI Masada", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "iwi_masada_slim", name: "IWI Masada Slim", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "iwi_masada_slim_elite", name: "IWI Masada Slim Elite", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "dwx_full", name: "DW DWX Full Size", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "dwx_compact", name: "DW DWX Compact (NON-RAILED ONLY)", ...DAISHO_NO_LB, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "1911_5", name: "1911 Standard Government 5\" W/ Rail", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "1911_425", name: "1911 4.25\" Commander W/ Rail", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "kimber_r7", name: "Kimber R7", ...IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "kimber_evo", name: "Kimber Evo", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "sccy_dvg_2", name: "SCCY 2 DVG-1RD", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE },
    { id: "rost_martin_rm1c", name: "Rost Martin RM1C", ...RH_IWB_ONLY, supported_lights: LIGHT_GROUPS.NONE, supported_lights_lh: LIGHT_GROUPS.NONE }
  ],

  // ==============================================================================
  // WEAPON LIGHTS
  // ==============================================================================
  lights: [
    { id: "tlr1_hl", name: "Streamlight TLR-1/HL" },
    { id: "tlr2", name: "Streamlight TLR-2/HL" }, 
    { id: "tlr7_a_x", name: "Streamlight TLR-7/A/X" },
    { id: "tlr7_sub_glock", name: "Streamlight TLR-7 Sub (Glock)" },
    { id: "tlr7_sub_p365", name: "Streamlight TLR-7 Sub (Sig)" },
    { id: "tlr7_sub_1913", name: "Streamlight TLR-7 Sub (1913)" },
    { id: "tlr7_hlx", name: "Streamlight TLR-7 HL-X" },
    { id: "x300u_a", name: "Surefire X300 U/A/B" },
    { id: "xsc", name: "Surefire XSC" },
    { id: "xvl2", name: "Surefire XVL2" },
    { id: "x400", name: "Surefire X400 Ultra" },
    { id: "xc2", name: "Surefire XC2" }, 
    { id: "wild1", name: "Inforce WILD 1" },
    { id: "wild2", name: "Inforce WILD 2" },
    { id: "inforce_aplc_glock", name: "Inforce APLc (Glock / P-10C)" }, 
    { id: "pl350", name: "Modlite PL350" }
  ],

  // ==============================================================================
  // PATTERNS & COLORS
  // ==============================================================================
  colors: [
    /*
    { 
      id: "frog_skin", 
      name: "Frog Skin", 
      price: 0, 
      woo_variation_id: 275780, 
      category: "Limited Patterns" 
    },
    */
    // Crystal Lake is first, so it is the active drop: DEFAULT_COLOR_ID in
    // LimitedEditionBuilder reads colors[0]. Put the current drop at the top of
    // this list to make it the default selection and the first swatch shown.
    {
      id: "crystal_lake",
      name: "Crystal Lake",
      price: 0,
      // Variation on parent product 283913. The name above is sent as
      // attribute_patterns on add-to-cart, so it must match the WooCommerce
      // attribute option text character for character.
      woo_variation_id: 296129,
      category: "Limited Patterns",
      // Swatch: drop crystal_lake.jpg into /images/swatches/ and uncomment.
      // Without it the chip renders as flat grey.
      // img: "/images/swatches/crystal_lake.jpg",
      description: ""
    },
    { 
      id: "chocolate_chip", 
      name: "Chocolate Chip", 
      price: 0, 
      woo_variation_id: 283914, 
      category: "Limited Patterns",
      // description: "" // add copy here and it renders under the swatches
    },
    { 
      id: "chodesian_bushstroke", 
      name: "Chodesian Bushstroke Peniflage\u2122", 
      price: 0, 
      // Woo variation on parent product 283913, attribute Patterns =
      // "Chodesian Bushstroke Peniflage\u2122". Name below must stay in sync with
      // the attribute option in WooCommerce.
      woo_variation_id: 293176, 
      category: "Limited Patterns",
      description: "We have decided to release a very small quantity of available holsters in Chodesian Bushstroke Peniflage\u2122, inspired by the classic Rhodesian Brushstroke camo pattern. You can find all the wonderful phallic shapes in the details of the holster print. Carry your Appendicks Holster with veiny triumphant pride."
    }
  ],

  // ==============================================================================
  // APPAREL ADD-ON
  // ==============================================================================
  // Optional tee sold alongside the current drop. The builder price is lower than
  // the shelf price; the plugin sets the cart line from anr_addon_price, so the
  // product's own price is untouched for anyone buying it from its product page.
  //
  // Set to null to run a drop with no shirt - the section then renders nothing.
  apparel: {
    id: "crystal_lake_tee",
    name: "Crystal Lake Tee",
    builder_price: 19.99,
    retail_price: 24.99,

    // Parent (variable) product; the ids below are its variations. WooCommerce
    // needs the parent on add-to-cart as well as the variation.
    woo_product_id: 296131,

    // Woo attribute slug for size, without the "attribute_" prefix. A global
    // attribute is usually "pa_size"; a per-product one is usually "size".
    // Check a variation permalink: /?attribute_pa_size=Large
    attribute_slug: "pa_size",

    // Product photo. Shown as a thumbnail beside the size picker and enlarged on
    // hover (tap on mobile). If the file is missing the thumbnail hides itself
    // and the size picker still works, so the drop is not blocked on the shoot.
    img: "/wp-content/uploads/anr-assets/images/info/crystal_lake_shirt.jpg",
    description: "Limited Crystal Lake tee, printed to match the drop. Only available at this price when bought with a holster.",

    sizes: [
      { id: "sm",  name: "Small",  woo_variation_id: 296132 },
      { id: "md",  name: "Medium", woo_variation_id: 296133 },
      { id: "lg",  name: "Large",  woo_variation_id: 296134 },
      { id: "xl",  name: "XL",     woo_variation_id: 296135 },
      { id: "xxl", name: "XXL",    woo_variation_id: 296136 }
    ]
  },

  // --- WING COLORS ---
  // Current production wings are Curv. Carbon fiber is shelved and will return as
  // Tegris — its entry is retained below, commented out, so it can be restored in
  // one line without re-deriving the id or image names.
  wing_colors: [
    { id: "odg", name: "OD Green Curv Wing", price: 0 },
    { id: "coyote_carbon", name: "Coyote Curv Wing", price: 0 },
    { id: "black", name: "Black Curv Wing", price: 0 }
    // { id: "carbon_fiber", name: "Carbon Fiber Tegris Wing", price: 0 },
  ],

  // ==============================================================================
  // MOUNTS 
  // ==============================================================================
  mounts: [
    // --- IWB MOUNTS ---
    { 
      id: "clip_15", 
      name: "1.5\" Injection Molded Clip", 
      price: 0, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/fomo_clip_front.png", 
      img_layer_mount_back: "/images/mounts/fomo_clip_back.png",
      description: "Standard injection molded clip. Durable, reliable, reverse tab."
    },
    { 
      id: "clip_175", 
      name: "1.75\" Injection Molded Clip", 
      price: 0, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/fomo175_clip_front.png", 
      img_layer_mount_back: "/images/mounts/fomo_clip_back.png",
      description: "Standard injection molded clip for wider belts."
    },
    { 
      id: "dcc_ANRlogo_iwb", 
      name: "1.5\" DCC ANR Logo", 
      price: 7.25, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/dccanrlogo_front.png", 
      img_layer_mount_back: "/images/mounts/dccanrlogo_back.png", 
      description: "Heat treated steel alloy. High clamping force."
    },
    { 
      id: "dcc_nologo_iwb", 
      name: "1.5\" DCC No Logo", 
      price: 6.25, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/dcc_nologo_back.png", 
      description: "Heat treated steel alloy. Clean, no logo finish."
    },
    { 
      id: "dcc_TOPOlogo_iwb", 
      name: "1.5\" DCC TOPO", 
      price: 8.25, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/dcctopo_front.png", 
      img_layer_mount_back: "/images/mounts/dcctopo_back.png", 
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
      id: "dcc_FDElogo_iwb", 
      name: "1.5\" DCC FDE", 
      price: 7.25, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/dccfde_front.png", 
      img_layer_mount_back: "/images/mounts/dccfde_back.png", 
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "neomag_iwb", 
      name: "NeoMag Alias", 
      price: 15.99, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/neomag_front.png", 
      img_layer_mount_back: null,
      description: "Premium clip-less system. Requires NeoMag Alias belt receiver."
    },
    {
      id: "neomag_receiver_iwb", 
      name: "NeoMag Alias T Post and Receiver", 
      price: 49.99, 
      is_iwb: true, is_daisho: false,
      img_layer_mount: "/images/mounts/neomagreciever_front.png", 
      img_layer_mount_back: null,
      description: "Includes Neomag T Post + Receiver Addon for belt."
    },

    // --- DAISHO MOUNTS ---
    { 
      id: "dcc_ANRlogo", name: "1.5\" DCC ANR Logo", price: 7.25, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/dccanrlogo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dccanrlogo_back.png", 
      description: "Heat treated steel alloy. High clamping force."
    },
    { 
      id: "dcc_TOPOlogo", name: "1.5\" DCC TOPO", price: 8.25, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/dcctopo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dcctopo_back.png", 
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
      id: "dcc_nologo", name: "1.5\" DCC No Logo", price: 6.25, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dcc_nologo_back.png",
      description: "Heat treated steel alloy. Clean, no logo finish."
    },
    { 
      id: "dcc_FDElogo", name: "1.5\" DCC FDE", price: 7.25, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/dccfde_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dccfde_back.png", 
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "neomag_daisho", name: "NeoMag Alias TPost", price: 15.99, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/neomag_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/neomag_back.png", 
      description: "Premium clip-less system. Requires NeoMag Alias belt receiver."
    },
    {
      id: "neomag_receiver_daisho", name: "NeoMag Alias and Neomag Alias Belt Receiver", price: 49.99, 
      is_iwb: false, is_daisho: true, no_light_suffix: true,
      img_layer_mount: "/images/mounts/daisho/neomagreciever_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/neomagreciever_back.png", 
      description: "Neomag T Post attached to the holster with the Receiver Addon."
    }
  ],

  // ==============================================================================
  // ACCESSORIES
  // ==============================================================================
  claws: [
    { id: "no",  name: "No Thanks", price: 0 },
    { 
      id: "black", 
      name: "Black Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/claw_front.png", 
      img_layer_claw_back:  "/images/claws/claw_back.png" 
    },
    { 
      id: "odg", 
      name: "OD Green Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/claw_odg_front.png", 
      img_layer_claw_back:  "/images/claws/claw_odg_back.png" 
    },
    { 
      id: "coyote", 
      name: "Coyote Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/claw_coy_front.png", 
      img_layer_claw_back:  "/images/claws/claw_coy_back.png" 
    }
  ],

  warranties: [
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 },
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 }
  ]
};